import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import {
  BGColor02,
  blackShade19,
  blueColor04,
  greyColor9,
  mobilePrimary,
  whiteColor,
} from "../../../../../configs/styles/muiThemes";
import ConfirmationCard1 from "./ConfirmationCard1";
import ConfirmationCard2 from "./ConfirmationCard2";
import ConfirmationCard3 from "./ConfirmationCard3";

function OndcApproveConfirmation({
  handleCancel,
  onSubmit,
  activeCard,
  loader,
  ondcCartData,
  qty,
}) {
  return (
    <Box sx={{ background: whiteColor, borderRadius: "10px" }}>
      <Box
        sx={{
          backgroundColor: BGColor02,
          p: "10px 15px",
          borderRadius: "10px 10px 0 0",
        }}
      >
        <Typography
          fontSize={{ md: 17, xs: 16 }}
          fontWeight={600}
          color={blackShade19}
          textAlign={"center"}
          mb={0.5}
        >
          Order Approve
        </Typography>
      </Box>
      <Box py={2} px={2} sx={styles.content}>
        {activeCard === 1 && <ConfirmationCard1 qty={qty} />}
        {activeCard === 2 && <ConfirmationCard2 onSubmit={onSubmit} />}
        {activeCard === 3 && <ConfirmationCard3 ondcCartData={ondcCartData} />}
      </Box>
      {activeCard !== 2 && (
        <Box
          sx={{
            backgroundColor: BGColor02,
            p: "10px 15px",
            borderRadius: "0 0 10px 10px",
            display: "flex",
            justifyContent: "center",
            gap: 3,
          }}
        >
          {activeCard === 1 && (
            <Button
              sx={styles.cancelBtn}
              variant="contained"
              disableElevation
              onClick={handleCancel}
              disabled={loader}
            >
              No
            </Button>
          )}
          <Button
            sx={styles.submitBtn}
            variant="contained"
            disableElevation
            onClick={onSubmit}
            disabled={loader}
          >
            {activeCard !== 1 ? "OK" : "Yes"}
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default OndcApproveConfirmation;

const styles = {
  content: {
    maxHeight: "70vh",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },
  submitBtn: {
    padding: "5px 16px",
    width: { md: "auto", xs: "auto" },
    fontSize: "12px",
    fontWeight: 600,
    backgroundColor: { md: blueColor04, xs: mobilePrimary },
    color: whiteColor,
    border: {
      md: "1px solid " + blueColor04,
      xs: "1px solid " + mobilePrimary,
    },
    "&:hover": {
      backgroundColor: whiteColor,
      color: { md: blueColor04, xs: mobilePrimary },
    },

    "&.Mui-disabled": {
      border: "none",
    },
  },
  cancelBtn: {
    padding: "5px 16px",
    width: { md: "auto", xs: "auto" },
    fontSize: "12px",
    fontWeight: 600,
    color: blackShade19,
    backgroundColor: whiteColor,
    border: "1px solid " + blackShade19,
    "&:hover": {
      color: whiteColor,
      backgroundColor: blackShade19,
    },

    "&.Mui-disabled": {
      border: "none",
    },
  },
};
